import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

import TableCell from "@material-ui/core/TableCell";
import FindReplaceIcon from "@material-ui/icons/FindReplace";
import Tooltip from "@material-ui/core/Tooltip";
import TableConfigurator from "./TableConfigurator";

const useStyle = makeStyles(theme => ({
  field: { padding: theme.spacing(0, 2, 0, 2) },
  pointer: {
    cursor: "pointer",
  },
  inline: {
    display: "flex",
    maxWidth: "100%",
    flexWrap: "wrap",
  },
  toolTipFontSize: {
    fontSize: "0.7rem",
  },
  tooltipMargin: {
    margin: theme.spacing(0),
  },
  positionEnd: {
    justifyContent: "flex-end",
    display: "flex",
    flexGrow: 1,
  },
}));

const TableCellComponent = (classes, onClickSearch, value, props, style) => (
  <TableCell
    className={`${classes.field} ${onClickSearch ? classes.pointer : ""}`}
    id={value}
    {...props()}
    onClick={
      onClickSearch
        ? () => {
            onClickSearch();
          }
        : null
    }
  >
    <div className={classes.inline}>
      {value !== -1 ? value : "-"}
      {onClickSearch ? (
        <div className={`${classes.positionEnd}`} style={style}>
          <FindReplaceIcon />
        </div>
      ) : null}
    </div>
  </TableCell>
);

const CellComponent = ({ value, onClickSearch, toolTip, type, item }) => {
  const classes = useStyle();
  const [ownValue, setOwnValue] = useState(undefined);
  const [updateId, setUpdateId] = useState(undefined);
  useEffect(() => {
    setOwnValue(TableConfigurator[item].value(value));
    if (value === -1 && type === "date") setOwnValue("-");
    if (type === "date" && updateId === undefined && value !== -1) {
      const interval = setInterval(() => {
        setOwnValue(TableConfigurator[item].value(value));
      }, 60000);
      setUpdateId(interval);
    }
    return () => {
      if (updateId !== undefined) {
        clearInterval(updateId);
        setUpdateId(undefined);
      }
    };
  }, [setOwnValue, ownValue, updateId, setUpdateId, value, type, item]);
  const [style, setStyle] = useState({ color: "rgba(0, 0, 0, 0)" });
  const props = () => {
    return onClickSearch
      ? {
          onMouseEnter: () => setStyle({ color: "rgba(0, 0, 0, 0.54)" }),
          onMouseLeave: () => setStyle({ color: "rgba(0, 0, 0, 0)" }),
        }
      : {};
  };
  return !toolTip ? (
    TableCellComponent(classes, onClickSearch, ownValue, props, style)
  ) : (
    <Tooltip
      classes={{ tooltipPlacementTop: classes.tooltipMargin, tooltip: classes.toolTipFontSize }}
      title={toolTip}
      enterDelay={1000}
      placement="top"
    >
      {TableCellComponent(classes, onClickSearch, ownValue, props, style)}
    </Tooltip>
  );
};

CellComponent.defaultProps = {
  onClickSearch: undefined,
  toolTip: undefined,
  type: undefined,
};

CellComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClickSearch: PropTypes.func,
  toolTip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  item: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  translation: state.ui.translation,
});

const Cell = connect(mapStateToProps)(CellComponent);

export default Cell;
